/**
 * Splits dense penalty / exposure prose for tooltip display.
 * Uses Unicode circled digits (①…) as major breakpoints, then semicolons for long segments.
 */
const CIRCLED_DIGIT_ANYWHERE = /[\u2460-\u2473]/u;
const CIRCLED_DIGIT_PREFIX = /(?=[\u2460-\u2473])/u;
const SEMICOLON_CLAUSE = /\s*;\s+/;

const MAX_SINGLE_BLOCK_CHARS = 340;

export function stripLeadingWarningPrefix(text: string): string {
  return text.replace(/^\s*\u26A0\uFE0F?\s*/u, "").trim();
}

export function splitPenaltyTextForTooltip(text: string): string[] {
  const normalized = stripLeadingWarningPrefix(text)
    .replace(/\s+/g, " ")
    .trim();
  if (!normalized) return [];

  const hasCircled = CIRCLED_DIGIT_ANYWHERE.test(normalized);
  const majorParts = hasCircled
    ? normalized
        .split(CIRCLED_DIGIT_PREFIX)
        .map((p) => p.trim())
        .filter(Boolean)
    : [normalized];

  const blocks: string[] = [];
  for (const part of majorParts) {
    if (part.length <= MAX_SINGLE_BLOCK_CHARS) {
      blocks.push(part);
      continue;
    }
    const bySemi = part
      .split(SEMICOLON_CLAUSE)
      .map((p) => p.trim())
      .filter(Boolean);
    if (bySemi.length > 1) {
      blocks.push(...bySemi);
    } else {
      blocks.push(part);
    }
  }

  return blocks.length > 0 ? blocks : [normalized];
}
